import { pulse } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const regular = css`
  width: 100%;
  border-radius: ${pxToRem(6)};
  ${pulse}
`;

export const short = css`
  ${regular}
  width:${pxToRem(60)};
`;
